import React, { useEffect, useMemo, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import {
  getTrainerAssignedData,
  getTutorsList,
} from "../../redux/features/batchSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TutorStatusChange from "./TutorStatusChange";
import { Batch_Assigned_Tutor } from "../../components/datagrid/myworkspace/cro/BatchTutorAssign";
import { useLocation, useNavigate } from "react-router-dom";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";

const Assigntutor = ({}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [statusOpen, setStatusOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const BatchID = searchParams.get("BatchID");

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const { loading, alltutors, trainerassigneddata } = useSelector(
    (state) => state.batch
  );

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getTrainerAssignedData(BatchID));
  }, []);

  const handleNavigation = (subject_enrollment_id, subject_name) => {
    navigate(
      `/my-workspace/assign-trainer?subjectEnrollId=${subject_enrollment_id}&subject=${subject_name}`
    );
  };

  const columns = useMemo(
    () => [
      ...Batch_Assigned_Tutor,
      {
        field: "assign",
        minWidth: 150,
        headerName: "Assign Tutor",
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="outlined"
              disabled={params.row.mapping_status === 1}
              color="primary"
              onClick={() =>
                handleNavigation(
                  params.row.subject_enrollment_id,
                  params.row.subject_name
                )
              }
            >
              <Icon
                icon={"streamline:one-finger-tap-solid"}
                width={18}
                height={18}
              />
              Assign
            </Button>
          );
        },
      },
      {
        field: "status",
        minWidth: 200,
        headerName: "Change Status",
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              disabled={params.row.trainer_name === null}
              onClick={() => {
                setSelectedRow(params.row);
                setStatusOpen(true);
              }}
            >
              <Icon
                icon={"material-symbols:person-edit"}
                width={18}
                height={18}
              />
              Change Status
            </Button>
          );
        },
      },
    ],
    [Batch_Assigned_Tutor]
  );

  return (
    <GlobalWrapper
      title={"Assigned Tutors"}
      actions={
        <Box>
          <Button
            size="small"
            variant="outlined"
            color="secondary"
            onClick={() => navigate(-1)}
          >
            <Icon icon={"lets-icons:back"} width={18} height={18} />
            Back
          </Button>
        </Box>
      }
    >
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={trainerassigneddata}
          //   meta={batches?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={false}
        />
        {statusOpen && selectedRow && (
          <TutorStatusChange
            rowData={selectedRow}
            open={statusOpen}
            setOpen={setStatusOpen}
            batchID={BatchID}
          />
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default Assigntutor;
